/**
 * Cookie Consent Banner Component
 *
 * NOTE: Banner is currently hidden. Tracking is enabled by default.
 * To re-enable the consent banner, remove the early return.
 */

import React, { useEffect } from 'react';
import './CookieConsentBanner.css';
import { analyticsService } from '../../../services/analytics.service';

export const CookieConsentBanner: React.FC = () => {
  useEffect(() => {
    // Auto-enable tracking without showing consent banner
    // Set consent to true if not already set
    const consent = localStorage.getItem('analytics_consent');
    if (consent === null) {
      analyticsService.setConsent(true);
    } else {
      analyticsService.setConsent(consent === 'true');
    }
  }, []);

  // Banner is hidden - tracking is enabled by default
  return null;
};
